module.exports = __webpack_public_path__ + "img/UT0415.4b76867b.png";